import HomePage from "../pages/homePage";
import Navigation from "./navigation";


export default function Layout() {
    return (
      <div>
        <Navigation />
        <HomePage />
      </div>
    );
  }
  